import React from 'react'
import PropTypes from 'prop-types'

import { Content } from './styles'

function T4(props) {
  return <Content {...props} />
}

T4.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  font: PropTypes.string,
  color: PropTypes.string,
}

export default T4
